import filesize from 'filesize';
import _ from 'lodash';
import React from 'react';
import styles from './FileMetadata.module.scss';
import { AssetEntity } from 'src/modules/assets';
import classnames from 'classnames';

export interface FileMetadataProps {
  asset: AssetEntity;
  className?: string;
}

export const FileMetadata = ({ asset, className }: FileMetadataProps) => {
  return (
    <div className={classnames(styles.fileMetadata, className)}>
      {filesize((asset.file?.size || 0) * 1000)}, {_.trim(asset.file?.ext.toUpperCase(), '.')}
    </div>
  );
};
